import { ResourceModel } from "./generic-resource-model";

export class NotificationHistory extends ResourceModel<NotificationHistory> {
    public id: number;
    public title: string;
    public body: string;
    public sendDate: Date;
    public data: string;
    public notificationTypeID: number;
    public userID: number;

    constructor(model?: Partial<NotificationHistory>) {
        super(model);
    }
}

export class NotificationData {
    public ID: number;
    public UserID!: number;
    public RequisitionID!: number;
    public PaymentRequestID!: number;
    public CallbackUri: string;
}